import React from 'react';
const coverage = [{
  label: 'Block 1 · Warm-Up Rally',
  color: 'text-court-teal',
  body: 'Ball in play from minute one — nobody warming up in a line'
}, {
  label: 'Block 2 · Skill Block',
  color: 'text-[#5B9BE0]',
  body: 'One skill per session, in rotating stations so nobody waits'
}, {
  label: 'Block 3 · Situation Block',
  color: 'text-gold',
  body: 'That same skill taken into a real game situation'
}, {
  label: 'Block 4 · Live Play',
  color: 'text-crimson-deep',
  body: 'Real points, with one focus rule to lock the skill in'
}, {
  label: 'The Level Ladder',
  color: 'text-gold',
  body: 'Easier / on-level / harder on every drill — three levels, one court'
}, {
  label: 'The Rotation Grid',
  color: 'text-gold',
  body: 'A rotation for every group size, from 2 players to 16+'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-navy-mid" data-id="element-206" data-mp="1ullbputbjdf9">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-207" data-mp="1plpag3c0a03e">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-208" data-mp="1b05yo44okzqx">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-209" data-mp="1f0pv15hfjzc0">
          The Four-Block Session
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-210" data-mp="1orkkeipz3f1o">
          A drill isn&apos;t a session. A list of drills still leaves you
          deciding what to teach tomorrow, in what order, and what to do with
          mixed levels. Court Ready runs every lesson and clinic in the same four
          blocks, every week — only what goes inside each block changes, written
          on one Session Card. Pick up the card, set the court and run it. The
          Level Ladder makes it fit whoever shows up.
        </p>

        <ul className="mt-8 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-211" data-mp="2hgrjbitca6ng">
          {coverage.map(item => <li key={item.label} className="rounded-lg border border-navy-line bg-white/5 px-4 py-3" data-id="element-212" data-mp="1rs2tnqrsl667">
              <span className={`block text-[11px] font-bold uppercase tracking-widest ${item.color}`} data-id="element-213" data-mp="1mvvmjunntomo">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-214" data-mp="1wrp6hz3pkkeh">{item.body}</span>
            </li>)}
        </ul>

        <p className="mx-auto mt-7 max-w-2xl text-sm text-white/60" data-id="element-215" data-mp="192w8lx3j02h8">
          Every card also carries the Coach&apos;s Eye (what to watch), the most
          common error and its fix, and a Quick Win to apply before the next class.
        </p>
      </div>
    </section>;
}